import {Icon, Message, Modal} from 'semantic-ui-react';
import styled from 'styled-components';

export const CreateTeamModalContent = styled(Modal.Content)`
  min-height: 600px;
`;

export const ActionsWrapper = styled.span`
  display: inline-flex;
  width: 100%;
  align-items: center;
`;

export const ActionIcon = styled(Icon)`
  flex: 0 0 auto;
  margin: 0 10px 0 4px !important;
`;

export const DoubleCheckMessage = styled.span`
  text-align: left;
  flex: 1 0 auto;
`;

export const ActionButtonsWrapper = styled.span`
  flex: 0 0 auto;
`;
